import { isGranted } from "../services/AccessManager";
import capabilities from "../services/Capabilities";
import { routeCapability } from "./RouterUtils";
/**
 * Groups nav items by their category, in order of first occurrence. Items without a category are
 * listed first, in a group without a category. Hidden items are left out, so that a category whose
 * items are all hidden does not end up with a title and no items.
 */
export function groupNavItems(items) {
    const groups = [];
    const groupsByCategory = {};
    const ungrouped = { category: null, items: [] };
    groups.push(ungrouped);
    items.filter(item => !item.hidden).forEach(item => {
        if (!item.category) {
            ungrouped.items.push(item);
            return;
        }
        let group = groupsByCategory[item.category];
        if (!group) {
            group = { category: item.category, items: [] };
            groupsByCategory[item.category] = group;
            groups.push(group);
        }
        group.items.push(item);
    });
    return groups.filter(group => group.items.length > 0);
}
// Two independent questions: may the user see the feature, and does this deployment have it
//   at all. An item hidden for want of a capability would otherwise lead to a view with no
//   application behind it to answer.
export function isNavItemDisplayable(item, router) {
    return (!item.permission || isGranted(item.permission))
        && isAvailable(item.capability)
        && isAvailable(itemRouteCapability(item, router));
}
function isAvailable(capability) {
    return !capability || capabilities.has(capability);
}
/**
 * The capability the route behind the item needs. An item without a `url` links to
 * `{name: item.name}` (see NavigationItem), so its name *is* a route name: declaring
 * `meta.capability` on the route gates the URL, the tab bar and the sidebar item at once, and
 * an item need not repeat it. The guard resolves it the same way, so the two cannot disagree.
 */
function itemRouteCapability(item, router) {
    if (item.url || !item.name) {
        return undefined;
    }
    const record = router.getRoutes().find(route => route.name === item.name);
    // A route taking params cannot be reached from `{name}` alone, so an item pointing at one
    //   is not really navigable and there is nothing to gate - and resolving it would throw.
    //   That is the case for the per-entity tab bars, whose routes all carry an :id.
    if (!record || record.path.indexOf(':') !== -1) {
        return undefined;
    }
    try {
        return routeCapability(router.resolve({ name: item.name }).matched);
    }
    catch {
        return undefined;
    }
}
